import React from "react"

import styles from "./index.css"

const DangerouslyHTMLTextPriview = ({ content, className = "" }) => {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: content }}
      className={`${styles.customForm} ${className ?? ""}`}
    />
  )
}

export default DangerouslyHTMLTextPriview
